import useApiQuery from 'shared/hooks/use-api-query';
import productsKeys from '../util/products-keys';
import {ProductProps} from '../types';

const useProductDetails = (productId: string) => {
  return useApiQuery<ProductProps>({
    url: `/products/${productId}`,
    queryKey: productsKeys.details(productId),
  });
};

export default useProductDetails;
